import React from "react";
import { EMPTY_STRING } from "../../../constants";
import InputTextField from "../inputTextField/InputTextField";
import { PRODUCT_TYPES_ENUMS } from "../../../system/globalEnums";
import { isTcgPlayerApi } from "../../inventoryUtility";

// CardRarity is printing and rarity is rarity
const Rarity = (props) => {
  const {
    label = EMPTY_STRING,
    priceChartingProductInfo: { productMetaData },
    priceChartingProductInfo,
  } = props;

  return (
    isTcgPlayerApi(productMetaData) && (
      <>
        {label && <label className="field-label">{label}</label>}
        <InputTextField
          name="rarity"
          title="Rarity"
          maxLength={100}
          disabled={true}
          placeHolder="Enter Rarity"
          className="border"
          containerDivClassName="modal-input-field-min-width"
        />
      </>
    )
  );
};

export default Rarity;
